import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { PageShell } from "@/components/Layout";
import EventCard from "@/components/EventCard";

const COPY = {
  social: {
    overline: "Social Nights",
    titleA: "Social",
    titleB: "Events.",
    sub: "Cocktails, dinner, conversation — held at beautiful bars, restaurants and private rooms across the country. Open to couples, single ladies and exceptional single gentlemen. No play at social evenings.",
    empty: "No social evenings scheduled — check back shortly.",
    testId: "social-events-page",
  },
  spicy: {
    overline: "Spicy Nights · Play Permitted",
    titleA: "Spicy",
    titleB: "Events.",
    sub: "Hosted at specialist members' clubs where play is welcomed. Strict dress codes, vetted guest lists and a no-photos policy. Couples, single ladies and vetted single gentlemen.",
    empty: "No spicy evenings scheduled — check back shortly.",
    testId: "spicy-events-page",
  },
};

export default function EventsList({ type = "social" }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const copy = COPY[type];

  useEffect(() => {
    setLoading(true);
    api
      .get("/events", { params: { event_type: type } })
      .then((r) => setEvents(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [type]);

  return (
    <PageShell>
      <section className="px-6 lg:px-12 py-20" data-testid={copy.testId}>
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="mb-16 max-w-2xl"
          >
            <div className="font-mono-overline text-[#e2a9f1] mb-4">{copy.overline}</div>
            <h1 className="text-5xl md:text-6xl font-serif-display text-[#EDEDED] leading-tight">
              {copy.titleA} <span className="display-italic text-[#e2a9f1]">{copy.titleB}</span>
            </h1>
            <p className="text-[#A3A3A3] mt-6 leading-relaxed">{copy.sub}</p>
          </motion.div>

          {loading ? (
            <div className="text-[#A3A3A3] font-mono-overline">Loading…</div>
          ) : (
            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="events-grid">
              {events.map((e, i) => (
                <EventCard key={e.id} event={e} index={i} />
              ))}
              {events.length === 0 && (
                <div className="col-span-full text-[#A3A3A3] py-12 font-mono-overline">
                  {copy.empty}
                </div>
              )}
            </div>
          )}
        </div>
      </section>
    </PageShell>
  );
}
